import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiSearchApi, AiSearchApiImpl } from './apis';
import { DataCoverageApi, DataCoverageApiImpl } from './apis/dataCoverage';
import { EntityApi, EntityApiImpl } from './apis/entity';
import { SandboxFilesApi, SandboxFilesApiImpl } from './apis/files';
import { SynapseChartApi, SynapseChartApiImpl } from './apis/synapse-chart';
import { VisualReportApi, VisualReportApiImpl } from './apis/visual-report';

export const aiSearchContainer = new ContainerModule((bind) => {
    bind<AiSearchApi>(AiSearchApi).to(AiSearchApiImpl);
    bind<DataCoverageApi>(DataCoverageApi).to(DataCoverageApiImpl);
    bind<EntityApi>(EntityApi).to(EntityApiImpl);
    bind<SandboxFilesApi>(SandboxFilesApi).to(SandboxFilesApiImpl);
    bind<SynapseChartApi>(SynapseChartApi).to(SynapseChartApiImpl);
    bind<VisualReportApi>(VisualReportApi).to(VisualReportApiImpl);
});

export { AiSearchApi } from './apis';
export { DataCoverageApi } from './apis/dataCoverage';
export { EntityApi } from './apis/entity';
export { SandboxFilesApi } from './apis/files';
export { SynapseChartApi } from './apis/synapse-chart';
export { VisualReportApi } from './apis/visual-report';
